import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
//
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import NotificationNewPopover from './NotificationNewPopover';
import NetworkStatusBar from 'src/components/NetworksStatusBar copy/NetworkStatusBar';
import { useCallback, useEffect, useState } from 'react';
import Services from '../../../services/Services';
import TokenService from '../../../services/TokenService';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  // backgroundColor: 'rgb(218, 56, 49)',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const userID = TokenService.getUser()?.userID;

  // Bildirimleri API'den çek
  const fetchNotifications = useCallback(async () => {
    setLoading(true);
    try {
      const response = await Services.GetUserNotifications(userID);
      // console.log("User ID : ", userID)
      // console.log(response)
      // Yeni API'ya göre response.result dizisini işle
      if (response.data?.result) {
        setNotifications(
          response.data.result.map((notif) => ({
            id: notif.notificationID,
            title: notif.title,
            message: notif.content,
            isRead: notif.isRead === '1',
            createdAt: null, // API'de yok, gerekirse eklenebilir
          }))
        );
      }
    } catch (err) {
      console.error('Bildirimler alınamadı:', err);
    } finally {
      setLoading(false);
    }
  }, [userID]);

  // Bildirimleri periyodik olarak güncelle (örn: her 20 saniyede bir)
  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 600000); // 10 dakika
    return () => clearInterval(interval);
  }, [fetchNotifications]);

  // Bildirimi okundu olarak işaretle
  const handleMarkAsRead = useCallback(async (notificationId) => {
    try {
      await Services.SetReadNotification(notificationId);
      // Bildirimi yerel state'te güncelle
      setNotifications(prevNotifications =>
        prevNotifications.map(notif =>
          notif.id === notificationId ? { ...notif, isRead: true } : notif
        )
      );
    } catch (err) {
      console.error('Bildirim okundu olarak işaretlenemedi:', err);
    }
  }, []);

  // Tüm bildirimleri okundu olarak işaretle
  const handleMarkAllAsRead = useCallback(async () => {
    
    const unreadNotifications = notifications.filter(n => !n.isRead);
    try {
      await Promise.all(
        unreadNotifications.map(n => Services.SetReadNotification(n.id))
      );
      // Tüm bildirimleri yerel state'te okundu olarak işaretle
      setNotifications(prevNotifications =>
        prevNotifications.map(notif => ({ ...notif, isRead: true }))
      );
    } catch (err) {
      console.error('Bildirimler okundu olarak işaretlenemedi:', err);
    }
  }, [notifications]);

  return (
    <StyledRoot>
      <NetworkStatusBar />
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <Iconify style={{ height: '30px', width: '30px' }} icon="eva:menu-2-fill" />
        </IconButton>

        <Searchbar />
        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          {/* <LanguagePopover /> */}
          <NotificationNewPopover 
            notifications={notifications}
            loading={loading}
            onMarkAsRead={handleMarkAsRead}
            onMarkAllAsRead={handleMarkAllAsRead}
            onRefresh={fetchNotifications}
          />
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
